import { startsWith } from 'lodash'
import React, { useState, useEffect, useRef } from 'react'
import { Form, Button } from 'react-bootstrap'

function GreaterThanFilterPopover({ column, params, setParams, onClose, onSetHandleApply, canEdit = true, hideApplyButton = false }) {
  const prefix = column.section_abbreviation?.toLowerCase()
  let accessorKey = column.accessor_key

  if (startsWith(column.accessor_key, prefix)) {
    const suffix = column.accessor_key.slice(prefix.length)
    accessorKey = `${prefix}Min${suffix}`
  }

  const [currentValue, setCurrentValue] = useState(params[accessorKey] || '')

  // Track initial value to detect changes
  const initialValue = useRef(params[accessorKey] || '')

  const handleChange = (e) => {
    if (!canEdit) return
    const newValue = e.target.value
    setCurrentValue(newValue)
  }

  const handleApply = () => {
    // Only update params if value has changed
    if (currentValue !== initialValue.current) {
      setParams((p) => ({ ...p, [accessorKey]: currentValue }))
    }
    onClose()
  }

  useEffect(() => {
    if (onSetHandleApply) {
      onSetHandleApply(handleApply)
    }
  }, [currentValue]) // eslint-disable-line react-hooks/exhaustive-deps

  // Auto-apply changes when hideApplyButton is true
  useEffect(() => {
    if (hideApplyButton) {
      setParams((p) => ({ ...p, [accessorKey]: currentValue }))
    }
  }, [currentValue, hideApplyButton, setParams, accessorKey])

  const handleClear = () => {
    setCurrentValue('')
    setParams((p) => ({ ...p, [accessorKey]: '' }))
  }

  return (
    <div>
      <div className="mb-3">
        <strong>{column.name}</strong>
      </div>

      <div className="mb-3">
        <Form.Label className="small">Minimum Value</Form.Label>
        <Form.Control
          type="number"
          placeholder={`Min ${column.name}`}
          value={currentValue}
          onChange={handleChange}
          step="any"
          size="sm"
          disabled={!canEdit}
        />
      </div>

      {!hideApplyButton && (
        <div className="d-flex justify-content-between gap-2">
          {canEdit && (
            <Button variant="light" size="sm" onClick={handleClear}>
              Clear
            </Button>
          )}
          <Button variant="primary" size="sm" onClick={canEdit ? handleApply : onClose}>
            {canEdit ? 'Apply' : 'Close'}
          </Button>
        </div>
      )}
    </div>
  )
}

export default GreaterThanFilterPopover
